module.exports = __webpack_public_path__ + "static/media/banner-1-1-moc.b7b10929.png";